import React from 'react'
import Grid from '@material-ui/core/Grid'
import { useStyles } from '../pages/styled'
import theme from '../theme'

type RowLayoutProps = {
  text: string
  data: any
}

export const RowLayout = ({ text, data }: RowLayoutProps) => {
  const classes = useStyles(theme)
  return (
    <Grid
      item
      xs={12}
      sm={12}
      xl={12}
      container
      className={classes.gridOverview}
      spacing={2}
    >
      <Grid item xl={6} xs={6} sm={6} className={classes.fieldSize}>
        {text}
      </Grid>
      <Grid item xl={6} xs={6} sm={6} className={classes.fieldSize}>
        {data}
      </Grid>
    </Grid>
  )
}
